import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserOrgService {

  private orgIdSubject = new BehaviorSubject<string | null>(null);
  private userIdSubject = new BehaviorSubject<string | null>(null);
  private oneSignalUserIdSubject = new BehaviorSubject<string | null>(null);

  // Expose an observable of the org ID
  orgId$ = this.orgIdSubject.asObservable();
  userId$ = this.userIdSubject.asObservable();
  oneSignalUserId$ = this.oneSignalUserIdSubject.asObservable();

  constructor() { //to preservce the organisationId on refresh(Use case- to pass organisationId for staffOnBoarding)
    if (sessionStorage.getItem('LOGIN')) {
      const storedOrgId = sessionStorage.getItem('orgId');
      const storedUserId = sessionStorage.getItem('orgUser');
      const storedOneSignalUserId = sessionStorage.getItem('oneSignalUserId');

      if (storedOrgId) {
        this.orgIdSubject.next(storedOrgId);
      }
      if (storedUserId) {
        this.userIdSubject.next(storedUserId);
      }
      if (storedOneSignalUserId) {
        this.oneSignalUserIdSubject.next(storedOneSignalUserId);
      }
    }
  }

  // Method to set the org ID (e.g., on login)
  setOrgId(orgId: string) {
    this.orgIdSubject.next(orgId);
    sessionStorage.setItem('orgId', orgId); // Persist to localStorage
  }

  // Method to clear the org ID (e.g., on logout)
  clearOrgId() {
    this.orgIdSubject.next(null);
    sessionStorage.removeItem('orgId'); // Clear from localStorage
  }

  getSelectedOrg(): string | null {
    let orgIds =  this.orgIdSubject.getValue();
    return orgIds ? orgIds: null
  }

  // Method to get the current org ID value
  getOrgId(): string | null {
    return this.orgIdSubject.getValue();
  }

  // Method to set the user ID (e.g., on login)
  setUserId(userId: string) {
    this.userIdSubject.next(userId);
    sessionStorage.setItem('orgUser', userId); // Persist to localStorage
  }

  setOneSignalUserId(oneSignalUserId: string) {
    this.oneSignalUserIdSubject.next(oneSignalUserId);
    sessionStorage.setItem('oneSignalUserId', oneSignalUserId);
  }

  // Method to clear the user ID (e.g., on logout)
  clearUserId() {
    this.userIdSubject.next(null);
    sessionStorage.removeItem('orgUser'); // Clear from localStorage
  }

  clearOneSignalUserId() {
    this.oneSignalUserIdSubject.next(null);
    sessionStorage.removeItem('oneSignalUserId');
  }

  // Method to get the current user ID value
  getUserId(): string | null {
    return this.userIdSubject.getValue();
  }

  getOneSignalUserId(): string | null {
    return this.oneSignalUserIdSubject.getValue();
  }
}
